import { validateWithYupSchema as validateWithYupSchemaShared } from '@hrlogics/react-form-utils/yup';

/**
 * This wrapper is created to prevent TypeScript from swearing at type incompatibilities.
 * In the future, when validation of all forms will be switched to zod, it can be removed
 */

export const validateWithYupSchema = (...args: Parameters<typeof validateWithYupSchemaShared>) => {
  return validateWithYupSchemaShared(...args);
};
